import "./UpdateTicketOpen.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import newRequest from "../../context/newRequest";

const UpdateTicketOpen = ({ inputs, title }) => {
  const [ticketOpen, setTicketOpen] = useState({});
  const [ticketUpdateOpen, setTicketUpdateOpen] = useState({});
  const [categoryId, setCategoryId] = useState(false);
  const [statusId, setStatusId] = useState(false);
  const [sending, setSending] = useState("");
  const { ticketId } = useParams();
  const user = localStorage.getItem("user");
  const { data, loading, error } = useFetch(`/ticket/${ticketId}`);
  const navigate = useNavigate();

  useEffect(() => {
    setTicketOpen(data);
  }, [data]);



  const handleSelectCategoryID = (e) => {
    setTicketOpen(ticketOpen.status_id)
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setCategoryId(value);
  };

  const handleSelectStatusID = (e) => {
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setStatusId(value);
  };


  const handleChange = (e) => {
    setTicketUpdateOpen((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  console.log(ticketUpdateOpen)

  const handleClick = async (e) => {
    e.preventDefault();
    setSending("On Submit")
    try {

      const newTicketUpdate = {
        ...ticketUpdateOpen,
        category_id : categoryId[0],
        status_id : statusId[0]
      };

      const res= await newRequest.put(`/ticket/${ticketId}`, newTicketUpdate, {
        // headers
        headers: {
          'Authorization': `$Bearer ${user.token}`
        },
      });
      setSending("Sending...")

      if (res.status == 200) {
        setSending("Berhasil Mengirim Data Ticket Open")
        navigate(`/ticket/${ticketId}`);
      }
      console.log(res.status)
    } catch (err) {
      setSending(err.res.data.data.errors)
      console.log(err);
    }
  };
  return (
      <div className="new">
        <Sidebar />
        <div className="newContainer">
          <Navbar />
          <div className="top">
            <h1>{title}</h1>
          </div>
          <div className="bottom">
            <div className="right">
              <div className="detailItem">
                <span className="itemKey">Ticket ID:</span>
                <span className="itemValue">{ticketOpen.id}</span>
              </div>
              <form>
                <div>

                  <div className="formInput">
                    <label>Nomor TT</label>
                    <input type="text" placeholder={ticketOpen.number_ticket} onChange={handleChange}
                           id="number_ticket"/>
                    <label className="label">Status</label>
                    <select id="status_id" placeholder="DOWN" onChange={handleSelectStatusID}>
                      <option value="OPEN">Open</option>
                      <option value="PENDING">Pending</option>
                      <option value="SOLVED">Solved</option>
                      <option value="CANCELED">Cancel</option>
                    </select>
                    <label className="label">Category</label>
                    <select id="category_id" onChange={handleSelectCategoryID}>
                      <option value="">PILIH CATEGORY</option>
                      <option value="ONUBAD">ONU Bad</option>
                      <option value="FIBERCUT">Fiber Cut</option>
                      <option value="POWEROFF">Power OFF</option>
                      <option value="INTERMITTEN">INTERMITTEN</option>
                      <option value="LOOPING">LOOPING</option>
                      <option value="BENDING">BENDING</option>
                      <option value="ELECTRICAL">ELECTRICAL</option>
                      <label>Down Time</label>
                      <input type="text" placeholder={ticketOpen.down_time} onChange={handleChange} id="down_time"/>
                    </select>
                    <label>Segment Customer </label>
                  </div>
                  <textarea type="text" placeholder={ticketOpen.segment_customer} onChange={handleChange}
                            id="segment_customer"/>
                </div>
                <button onClick={handleClick}>Send</button>
              </form>
            </div>
          </div>
          {sending && <p className="error">{sending}</p>}
        </div>
      </div>
  );
};

export default UpdateTicketOpen;
